import { PureComponent } from "react";
import { Brightcove } from "./Brightcove/Brightcove";
import { Qumu } from "./Qumu/Qumu";
import { YoutubePreload } from "./Youtube/YoutubePreload";
import { OpenMeet } from "./OpenMeet/OpenMeet";

export class VideoPlayer extends PureComponent {
    static Brightcove = Brightcove;
    static Qumu = Qumu;
    static Youtube = YoutubePreload;
    static OpenMeet = OpenMeet;
}
